// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"171":"collection","185":"pdp","187":"report-issue","594":"demo","711":"warranty","962":"home"}[chunkId] + "." + {"171":"a02ff8db","185":"4b9b4e57","187":"de4560de","594":"1380672f","711":"074438e5","962":"832e2421"}[chunkId] + ".js";
};